import styled from "styled-components";

export const Wrapper = styled.main`
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 70px 0 0;
  width: 100%;
  height: calc(100vh - 70px);
  background: var(--body-bg);

  h1 {
    font-size: 22px;
    font-weight: 600;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
  }

  h5 {
    font-size: 14px;
    font-weight: 600;
  }

  h6 {
    font-size: 12px;
    font-weight: 600;
  }

  #ideolo-board {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    margin: 0;
    height: 100vh;
  }
`;

export const Main = styled.div`
  overflow-y: scroll;
  flex-grow: 1;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(0, 0, 0, 0.05);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.15);
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 white;
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ alignCenter }) => (alignCenter ? "center" : "flex-start")};
  justify-content: ${({ alignCenter }) =>
    alignCenter ? "center" : "flex-start"};
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 20px 20px 40px;
  gap: 12px;
`;
